import React from 'react';

function BeakerBadge() {
  return (
    <svg
      width={24}
      height={32}
      viewBox="0 0 24 32"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="9" y="2" width="6" height="3" />
      <line x1="10" y1="5" x2="10" y2="13" />
      <line x1="14" y1="5" x2="14" y2="13" />
      <path d="M10 13 L3 29 L21 29 L14 13 Z" />
      <line x1="7" y1="22" x2="17" y2="22" />
    </svg>
  );
}

export default BeakerBadge;
